import { useState, useEffect } from "react";
import Header from "../components/Headers/Header.js";
import { get } from "../utils/apiManager.js";
import { useNavigate } from "react-router-dom";
import BarChart from "../components/Chart/Barchart.js";
import BillingOverview from "../components/Billing/BillingOverview.js";

const Index = (props) => {
  const [totalUsers, setTotalUsers] = useState(0);
  const [companies, setCompanies] = useState([]);
  const [companiesGraphData, setCompaniesGraphData] = useState([]);
  const [activeUsers, setActiveUsers] = useState(0);
  const [demoUsers, setDemoUsers] = useState(0);
  const [billing, setBilling] = useState(null);
  const Navigate = useNavigate();

  useEffect(() => { getAllUsers(); getBilling(); }, []);

  const getAllUsers = () => {
    get("/company/latest-users").then((res) => {
      setTotalUsers(res?.totalUsers);
      setActiveUsers(res?.activeUsers);
      setDemoUsers(res?.demoUsers || 0);
      setCompanies(res?.datas);
      setCompaniesGraphData(res?.fullMonthsData);
    }).catch((error) => console.log(error));
  };

  const getBilling = () => {
    get("/company/billing-summary").then((res) => {
      if (res?.status) setBilling(res);
    }).catch((error) => console.log(error));
  };

  const thStyle = {
    padding: '10px 16px',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.07em',
    textTransform: 'uppercase',
    color: '#9aa5c0',
    textAlign: 'left',
    borderBottom: '1px solid #edf0f7',
    background: '#f8f9fc',
    whiteSpace: 'nowrap',
  };

  const tdStyle = {
    padding: '13px 16px',
    fontSize: 14,
    color: '#3a4a6a',
    borderBottom: '1px solid #f0f2f8',
    verticalAlign: 'middle',
  };

  return (
    <div>

      {/* Stat cards */}
      <Header totalUsers={totalUsers} activeUsers={activeUsers} demoUsers={demoUsers} />

      {/* Billing numbers */}
      <BillingOverview data={billing} />

      {/* Latest Companies table */}
      <div style={{
        background: '#fff',
        borderRadius: 14,
        border: '1px solid #edf0f7',
        boxShadow: '0 1px 4px rgba(26,39,68,.05)',
        overflow: 'hidden',
        marginBottom: 24,
      }}>
        <div style={{
          padding: '18px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #edf0f7',
        }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Latest Companies</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Recently registered auction companies</p>
          </div>
          <button
            onClick={() => Navigate("/admin/user")}
            style={{
              background: '#AD2429',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '8px 18px',
              fontSize: 13,
              fontWeight: 700,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            See All
          </button>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Name', 'Company Name', 'Company Type', 'Email', 'Phone', 'Apt Suite', 'Status'].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {companies?.length > 0 ? companies.map((item) => (
                <tr
                  key={item?._id}
                  style={{ transition: 'background .1s' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <td style={{ ...tdStyle, fontWeight: 600, color: '#0a1628' }}>
                    {item?.firstName ? `${item.firstName} ${item.lastName}` : '—'}
                  </td>
                  <td style={tdStyle}>{item?.companyName || '—'}</td>
                  <td style={tdStyle}>{item?.companyType || '—'}</td>
                  <td style={tdStyle}>{item?.email || '—'}</td>
                  <td style={tdStyle}>{item?.phone || '—'}</td>
                  <td style={tdStyle}>{item?.addressAptSuite || '—'}</td>
                  <td style={tdStyle}>
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 5,
                      padding: '4px 10px',
                      borderRadius: 100,
                      fontSize: 12,
                      fontWeight: 700,
                      background: item?.isActive ? '#dcfce7' : '#fee2e2',
                      color: item?.isActive ? '#15803d' : '#b91c1c',
                    }}>
                      <span style={{ fontSize: 8 }}>●</span>
                      {item?.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={7} style={{ ...tdStyle, textAlign: 'center', padding: '40px', color: '#9aa5c0' }}>
                    No companies found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Bar chart */}
      <div style={{
        background: '#fff',
        borderRadius: 14,
        border: '1px solid #edf0f7',
        boxShadow: '0 1px 4px rgba(26,39,68,.05)',
        overflow: 'hidden',
        padding: '18px 24px',
      }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: '0 0 16px' }}>Companies Growth</h3>
        <BarChart companiesGraphData={companiesGraphData} />
      </div>

    </div>
  );
};

export default Index;
